let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hWzbf")).then(() => parcelRequire('efDDR'));